module.exports = __webpack_public_path__ + "img/2.06a01ea0.png";